import { useFormik } from 'formik'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import FormSelectShared from 'views/components/FormSelectShared'
import { SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { AnalyticsPlaces } from 'views/pages/User/analyticsPlaces'

import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'

import { Progress } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useNotification } from 'hooks/useNotification'
import { ModalProps } from '../../../types'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

export const BlockUserModal: FC<ModalProps> = ({ onClose, refetch, userId }) => {
  const { t } = useTranslation('user')
  const notify = useNotification()
  const { formProgress, formHandler } = useAFormHandler('blockUser', { id: userId })

  const formik = useFormik<{ blocked_reason: string }>({
    initialValues: {
      blocked_reason: '',
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.post(endpoints.blockUser(userId), formik.values)
      },
      {
        onSuccess: async () => {
          await refetch(true)
          onClose()
          notify(Progress.SUCCESS, { title: t('userBlocker') })
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <>
      <ASharedModal id={AnalyticsPlaces.BLOCK_MODAL} onClose={onClose} size="small">
        <SharedModalTitle>{t('block_user')}</SharedModalTitle>
        <SharedModalContent>
          <ContentWrapper>
            <div>{t('blockUserDescription')}</div>
            <div>{t('doYouReallyWantBlockUser')}</div>
            <FormSelectShared
              formik={formik}
              endpoint={endpoints.blockedReasons()}
              placeholder={t('blockUserPlaceholder')}
              fieldName="blocked_reason"
              simpleApiFormat
              showSearch={false}
              getLabel={(dto) => dto.label}
              hideLabel
              disableRightPadding
              allowClear={false}
            />
          </ContentWrapper>
        </SharedModalContent>
        <ADefaultModalFooter
          progress={formProgress}
          onClose={onClose}
          onConfirm={() => formik.submitForm()}
          confirmButtonText={t('common:block')}
          color="destruct"
          disabled={!formik.dirty}
        />
      </ASharedModal>
    </>
  )
}
